<template lang="html">
  <transition>
    <div v-if="visible" class="modal" :class="[`${categoryColor}-bg`]" @click.self="$emit('close')">
      <div class="container">
        <header>
        </header>
        <!-- the information shown in the modal is written in todoitem-->
        <slot/>
        <TodoButton class="leftButton" icon="close" :label="'close'" @click="$emit('close')"></TodoButton>
      </div>
    </div>
  </transition>
</template>

<script>
import TodoButton from '@/components/TodoButton.vue';

export default {
  components: {
    TodoButton,
  },
  props: {
    title: String,
    visible: Boolean,
    icon: String,
    label: String,
    id: Number,
    pageColor: String,
    todo: Object,
    categoryColor: String,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.modal
  filter: drop-shadow(2px 2px 8px rgba(67, 249, 206, 1))
  position: fixed
  top: 0
  margin-top: 0px
  left: 0
  right: 0
  bottom: 0
  z-index: 11
  display: flex
  justify-content: center

  @media $desktop
    justify-content: right
    left: auto
    margin-top: 80px

  @media $tablet
    justify-content: right
    left: auto
    margin-top: 80px

  &.v-enter-active,
  &.v-leave-active
    transition: opacity 350ms ease

    &.v-enter-active .container,
    &.v-leave-active .container
      transition: transform 350ms ease

    &.v-enter,
    &.v-leave-to
      opacity: 0

      &.v-enter .container,
      &.v-leave-to .container
        transform: translateY(2rem)

  .container
    background-color: transparent
    color: black
    width: 100%
    max-width: 640px
    border-radius: 2px
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase

    @media $desktop
      max-width: 440px

    @media $tablet
      max-width: 440px

    button
      margin-left: auto
      background-color: transparent !important
      color: black !important
      border: none
      border-radius: 50%
      cursor: pointer
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      font-size: 16px
      text-transform: uppercase
      padding: 10px
      padding-right: 15px
      padding-left: 5px
      border-radius: 2px
      display: inline-flex
      align-items: center
      bottom: 0
      margin-bottom: 20px

      .label
        width: 20px
        height: 20px
        margin-right: 20px

      &:focus
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px black

      &:active
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px black

      &:hover
         color: #C9D9D6
         background-color: transparent
         border: none
         outline: none
         border: solid 0.5px black

    .leftButton
      position: absolute
      display: inline-flex
      align-items: center
      left:0
      color: white
      margin-left: 30px
      bottom: 20px
      background-color: black
      border-radius: 2px
      border-top: solid 0.5px white
      border-bottom: solid 0.5px white
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      border-top: solid 0.5px black
      border-bottom: solid 0.5px black
      >>> .icon
        width: 15px
        height: 15px

    .rightButton
      position: absolute
      right:0
      margin-right: 30px
      bottom: 20px
      display: inline-flex
      align-items: center
      color: white !important
      background-color: black
      border-radius: 2px
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      border-top: solid 0.5px black
      border-bottom: solid 0.5px black
      >>> .icon
        width: 15px
        height: 15px


</style>
